import { ChevronLeft, ChevronRight } from 'lucide-react';
import { type MouseEventHandler } from 'react';

type Props = {
  direction: 'prev' | 'next';
  onClick: MouseEventHandler<HTMLButtonElement>;
  ariaLabel: string;
  size?: 'sm' | 'lg';
};

const SIZES = {
  sm: { box: 'h-9 w-9', icon: 20 },
  lg: { box: 'h-11 w-11', icon: 22 },
};

export default function CarouselButton({ direction, onClick, ariaLabel, size = 'sm' }: Props) {
  const { box, icon } = SIZES[size];
  const Icon = direction === 'prev' ? ChevronLeft : ChevronRight;
  const sideClass = direction === 'prev' ? 'left-3' : 'right-3';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={`absolute ${sideClass} top-1/2 flex -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-zinc-800 shadow-md transition hover:bg-white ${box}`}
    >
      <Icon size={icon} aria-hidden />
    </button>
  );
}
